module.exports = __webpack_public_path__ + "static/media/19.8652163f.jpg";